import React, { Fragment } from 'react';
import { Form, InputNumber } from 'antd';
import QuestionPopup from '../../../../../../common/components/questionPopup/questionPopup';
import { countDoorPopupContent } from '../contentsForPopover';

const DoorsAmount = ({ form, disabled }) => {
  const { getFieldDecorator } = form;
  return (
    <Fragment>
      <span className="label">Количество дверей:</span>
      <Form.Item>
        {getFieldDecorator('doorsAmount')(
          <InputNumber
            min={2}
            max={20}
            maxLength={2}
            placeholder="Укажите"
            className="smallInput"
            disabled={disabled}
          />
        )}
      </Form.Item>
      {disabled ? (
        <div></div>
      ) : (
        <QuestionPopup
          width="24px"
          height="24px"
          trigger="click"
          fill="#00a8ff"
        >
          {countDoorPopupContent}
        </QuestionPopup>
      )}
    </Fragment>
  );
};

export default DoorsAmount;
